import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "@ionic/angular";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { UploadAttachmentComponent } from "./upload-attachment.component";
import { ImagePreviewModule } from "../image-preview/image-preview.module";
import { ImagePreviewComponent } from "../image-preview/image-preview.component";
import { DragAndDropDirective } from "src/app/_directives/drag-and-drop.directive";
import { AvatarComponentModule } from "../avatar/avatar.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule,
        RouterModule,
        ImagePreviewModule,
        ReactiveFormsModule,
        AvatarComponentModule
    ],
    declarations: [UploadAttachmentComponent, DragAndDropDirective],
    exports: [UploadAttachmentComponent, DragAndDropDirective]
})
export class UploadAttachmentModule {}
